import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../constants/interaxColors'

/**
 * ActiveIndicator - The active indicator bar (Rectangle 30 from Figma)
 *
 * Shows a thin vertical orange bar on the right edge of active menu items
 * with a glow effect.
 */
export const ActiveIndicator: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '4px',
        height: '23px',
        right: '-0.67px',
        top: 'calc(50% - 23px/2 + 0.5px)',
        background: INTERAX_COLORS.sun,
        boxShadow: `0px 0px 8px ${INTERAX_COLORS.sun}`,
        filter: 'blur(1px)',
        borderRadius: '3px 0px 0px 3px',
        zIndex: 2
      }}
    />
  )
}
